import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PanelContenidoService {
  
  private altura$ = new BehaviorSubject<number>(0);

  setAltura(valor: number) {
    this.altura$.next(valor);
  }

  getAltura(): Observable<number> {
    return this.altura$.asObservable();
  }

  getAlturaActual(): number {
    return this.altura$.getValue();
  }

}